import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=0af7b2c0&scoped=true&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"
import style0 from "./TicketList.vue?vue&type=style&index=0&id=0af7b2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7b2c0",
  null
  
)

export default component.exports